import type { Options } from '@Types/Shared/Options';

import { createContext } from 'react';

export const defaultContext: Options = {
	blocks: {
		hero: {
			default: {
				id: '',
				contentFontFormats: {},
				variant: 'classic',
				containerType: 'wide',
			},
			compositions: [],
		},
		video: {
			default: {
				id: '',
				variant: 'small',
				containerType: 'wide',
				headingAlign: 'center',
			},
			compositions: [],
		},
		column: {
			default: {
				id: '',
				contentFontFormats: {},
				variant: 'classic',
				containerType: 'wide',
				cardType: 'wide',
				headingAlign: 'center',
			},
			compositions: [],
		},
		factFigure: {
			default: {
				id: '',
				contentFontFormats: {},
				variant: 'classic',
				containerType: 'wide',
				wrapperType: 'wide',
				headingAlign: 'center',
				factFigureAlign: 'center',
				factStyle: 'normal',
			},
			compositions: [],
		},
		editor: {
			default: {
				contentFontFormats: {},
				variant: 'classic',
				containerType: 'wide',
				headingAlign: 'center',
				wrapperType: 'block',
				quoteStyle: 'classic',
				tableStyle: 'classic',
			},
			compositions: [],
		},
		image: {
			default: {
				variant: 'classic',
				containerType: 'wide',
				headingAlign: 'center',
				id: '',
				contentFontFormats: {},
			},
			compositions: [],
		},
		teams: {
			default: {
				variant: 'classic',
				containerType: 'wide',
				headingAlign: 'center',
				contentFontFormats: {},
				imgType: 'squared',
				id: '',
			},
			compositions: [],
		},
		faqs: {
			default: {
				variant: 'classic',
				containerType: 'wide',
				headingAlign: 'center',
				id: '',
				contentFontFormats: {},
			},
			compositions: [],
		},
		txtImg: {
			default: {
				id: '',
				variant: 'classic',
				containerType: 'wide',
				headingAlign: 'center',
				contentFontFormats: {},
			},
			compositions: [],
		},
		news: {
			default: {
				variant: 'classic',
				containerType: 'wide',
				cardType: 'wide',
				headingAlign: 'center',
				readMoreHasIcon: false,
				readMoreDecorationElement: 'long',
				contentFontFormats: {},
				id: '',
			},
			compositions: [],
		},
		events: {
			default: {
				id: '',
				variant: 'classic',
				containerType: 'wide',
				cardType: 'wide',
				headingAlign: 'center',
				readMoreHasIcon: false,
				readMoreDecorationElement: 'long',
				iconType: 'fill',
				contentFontFormats: {},
			},
			compositions: [],
		},
		form: {
			default: {
				containerType: 'wide',
				headingAlign: 'center',
				wrapperType: 'center',
				id: '',
			},
			compositions: [],
		},
	},
	layout: {
		body: {
			bgColor: '',
		},
		header: {
			mainNav: {
				elements: {
					left: [],
					center: [],
					right: [],
				},
				types: {
					variantMenuChildItems: 'classic',
					logoSizeWidth: 120,
					logoSizeHeight: 60,
				},
			},
			topNav: {
				elements: {
					left: [],
					center: [],
					right: [],
				},
				types: {
					variantMenuChildItems: 'classic',
					logoSizeWidth: 120,
					logoSizeHeight: 60,
				},
			},
			headerVariants: 'classic',
		},
		footer: {
			contact: {
				address: {
					street: '',
					number: '',
					zip: '',
					city: '',
					country: '',
				},
				mail: '',
				phone: '',
			},
			colors: {
				bg: '',
				bottomBg: '',
				icon: '',
			},
			fontStyles: {
				titre: '',
				text: '',
				bottom: '',
			},
			socials: [],
			columns: [],
			logoSizeWidth: 120,
			logoSizeHeight: 60,
			displayCopyrightSpade: true,
		},
		events: {
			single: {
				variant: 'classic',
				relatedVariant: 'classic',
				imgType: 'squared',
				eventsInfoContainerType: 'wide',
				iconType: 'fill',
				displayDate: true,
				displayOrganizer: true,
				displayPlace: true,
				displayPrice: true,
				displayTag: true,
			},
			index: {
				variant: 'classic',
				headingVariant: 'leftInline',
				paginationVariant: 'bg',
				viewsChoices: 'both',
			},
		},
		faqs: {
			index: {
				variant: 'classic',
				headingVariant: 'leftInline',
				paginationVariant: 'bg',
			},
		},
		news: {
			single: {
				variant: 'classic',
				relatedVariant: 'classic',
				imgType: 'squared',
				displayAuthor: true,
				displayDate: true,
				displayTag: true,
			},
			index: {
				variant: 'classic',
				headingVariant: 'leftInline',
				paginationVariant: 'bg',
			},
		},
		teams: {
			single: {
				
			},
			index: {
				variant: 'classic',
				headingVariant: 'leftInline',
				paginationVariant: 'bg',
			},
		},
		page404: {
			textAlign: 'center',
			containerType: 'wide',
		},
		search: {
			variant: 'classic',
			headingVariant: 'leftInline',
			paginationVariant: 'bg',
		},
		script: {
			header: '',
			footer: '',
		},
		sectionDecoration: {
			isSectionDecorated: false,
			type: 'wave',
		},
	},
	colors: {
		palettes: [],
		colors: {},
	},
	fonts: {
		fontStyles: [],
	},
};

export const MinosContext = createContext<Options>(defaultContext);
